var render = function render(){var _vm=this,_c=_vm._self._c;return _c('battery',_vm._b({attrs:{"battery-level":_vm.position.$batteryLevel}},'battery',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }